"use client";

import { SkeletonLine, SkeletonPill } from "@health/ui";

/**
 * Loading skeleton mirroring BMIResult — outer widget card with a message
 * line and an inner primary-colored hero card showing a large BMI value, two
 * pill stats, and the medication-zone bar.
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link BMIResultWidget} chunk.
 */
export function BMIResultWidgetSkeleton() {
  return (
    <div className="bg-widget-bg rounded-2xl p-6 shadow-sm space-y-4 w-full">
      <SkeletonLine $size="text" $width="lg" />
      <div className="bg-primary/10 rounded-2xl p-6 space-y-4">
        <div className="space-y-2">
          <SkeletonLine $size="caption" $width="xs" />
          <div className="flex items-end gap-4">
            <SkeletonLine $size="heading" $width="xs" className="h-12" />
            <div className="flex gap-2 mb-1">
              <SkeletonPill $size="sm" $width="sm" />
              <SkeletonPill $size="sm" $width="sm" />
            </div>
          </div>
        </div>
        <div className="space-y-2 pt-4">
          <SkeletonLine $size="text" $width="full" className="h-2" />
          <div className="flex justify-between gap-2">
            {[0, 1, 2, 3].map((i) => (
              <SkeletonLine key={i} $size="caption" $width="xs" className="w-6" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
